import React from "react";
import { Translate } from "./LanguageChanger";
let resolution = window.RESOLUTION;
if (window.innerWidth >= 1920 && window.innerHeight >= 1080) {
  resolution = "FHD";
} else {
  resolution = "HD";
}
const userAgent = navigator.userAgent.toLowerCase();

if (
  userAgent.includes("webos") ||
  userAgent.includes("lg") ||
  userAgent.includes("web0s")
) {
  resolution = "FHD";
}
const ErrorScreen = ({ errorIcon, disply = "flex", bgcolor = "#000000" ,watchList, categories, homepage = false }) => {
  const styles = {
    ErrorScreenContainer: {
      display: disply,
      flexDirection: "column",
      background: watchList ? "none" : bgcolor,
      // background: "#0E1653",
      width: "100vw",
      height: "100vh",
      backgroundSize: "cover",
      backgroundPosition: "center", // Center the background image
      backgroundRepeat: "no-repeat", // Do not repeat the background image
      opacity: 0.7,
      overflow: "hidden",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      gap: watchList ? "15px" : "0"
    },

    image: {
      width: '250px',
      marginBottom: '20px',
    },
    heading: {
      fontSize: '30px',
      color: '#ffffff',
      margin: 0,
      fontWeight: '500',
            marginLeft: watchList ? "60px": "0"
    },
   subtext: {
      fontSize: "20px", 
      color: "#8F99B3",
      marginTop: "10px",
      textAlign: "center",
      maxWidth: "300px", // key: controls wrapping
      lineHeight: 1.3,
      wordWrap: "break-word",
            marginLeft: watchList ? "60px": "0"
    },
  };
   return (
    <div style={styles.ErrorScreenContainer}>
      <img src={errorIcon} style={{width: '250px', marginLeft: watchList ? "60px": "0" }} />
            {/* <h2 style={styles.heading}><Translate langKey={"No-list-founded"}/></h2> */}
                {  homepage || watchList ? <h2 style={styles.heading}><Translate langKey={"No-data-found"}/></h2>:<h2 style={styles.heading}><Translate langKey={"No-list-founded"}/></h2>}
      {watchList && (
        <p style={styles.subtext}>
          <Translate langKey={"No-list-found"} />
        </p>
      )}
      {!watchList &&!homepage && (
        <p style={styles.subtext}>
          <Translate langKey={"try-other-keyword"}/>
        </p>
      )}
      {!categories && !homepage && (
        <p style={styles.subtext}>
          <Translate langKey={"try-other-category"}/>
        </p>
      )}
    </div>
  );
};
export default ErrorScreen;
